// Module
var code = "<template>\n  <div if.bind=\"messagekey\" class=\"app-message\" class.bind=\"messageclass\" t.bind=\"messagekey\"></div>\n</template>\n";
// Exports
export default code;